export default __webpack_public_path__ + "static/bosch-298e1274740ea59b59bc25c260fc63ea.svg";